import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export default new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    silentTranslationWarn: process.env.NODE_ENV !== 'production',
    messages: {
        'it': {
            alerts: {
                empty: {
                    title: 'No Data found',
                    text: 'Some functions need more Data',
                    short: 'Needs more data'
                },
                error: {
                    title: 'Error while execution',
                    text: 'There was an Error while executing this task. Changes may not be saved or the Application is in Error.'
                },
                success: {
                    title: 'Success',
                    text: 'Changes successfully saved'
                },
                expired: {
                    title: 'Session expired',
                    text: 'Your Session expired. Please login again.'
                }
            },
            views: {
                Home: 'Home',
                Login: 'Accedi',
                Species: 'Specie',
                Researches: 'Ricerche',
                Research: 'Ricerca',
                AddSpecies: 'Aggiungi specie',
                SpeciesSingle: 'Specie',
                EditSpecies: 'Modifica specie',
                ResearchAdd: 'Aggiungi ricerca',
                Import: 'Importa file'
            },
            errors: {
                valid: 'Value has to be valid',
                required: 'Value is required'
            },
            labels:{
                hello: 'Ciao',
                logout: 'Esci',
                resetPassword: 'Modifica password',
                willBeResetted:'sarà reimpostata',
                pwdFor: 'La password per',
                pwdMinLen: 'La nuova password dovrà contenere almeno 8 caratteri',
                oldPassword: 'Vecchia password',
                newPassword: 'Nuova password',
                confirmNewPassword: 'Conferma nuova password',
                cancel: 'Annulla',
                confirm: 'Conferma',
                results: 'Risultati',
                search: 'Cerca...',
                multiselect: 'Selezione multipla',
                binomial: 'Nomenclatura binomiale',
                genus: 'Genere',
                family: 'Famiglia',
                selectFamily: 'Seleziona famiglia',
                order: 'Ordine',
                selectOrder: 'Seleziona ordine',
                suborder: 'Sottordine',
                continents: 'Continenti',
                anatomicParts: 'Parti anatomiche',
                reference: 'Riferimento',
                year: 'Anno',
                notes: 'Note',
                specimenCount: 'Numero di esemplari',
                registeredBy: 'Registrata da',
                researchDeleted: 'Ricerca eliminata',
                cranium: 'Cranio',
                lowerJaw: 'Mandibola inf.',
                teeth: 'Denti',
                hyoid: 'Ioide',
                vertebrae: 'Vertebre',
                ribs: 'Costole',
                girdles: 'Cinti',
                limbs: 'Arti',
                osteoderms: 'Osteodermi',
                shell: 'Guscio',
                oceania: 'Oceania',
                asia: 'Asia',
                europe: 'Europa',
                africa: 'Africa',
                america: 'America',
                moreResults: 'Mostra altri risultati',
                specificEpithet: 'Epiteto specifico',
                choose: 'Selezionare',
                confirmDeletion: 'Conferma eliminazione',
                speciesData: 'Dati della specie',
                confirmSpeciesQuestion: 'Vuoi davvero cancellare questa specie?',
                selectUnderOrderGrouping: 'Seleziona raggruppamento inferiore all\'ordine',
                underOrderGrouping: 'Raggruppamento inferiore all\'ordine',
                selectGenus: 'Seleziona genere',
                none: 'Nessuno',
                yesDelete: 'Si, elimina',
                speciesDeleted: 'Specie eliminata',
                reallyDelete: 'Vuoi davvero cancellare',
                thisResearch: 'questa ricerca',
                errorLoading: 'Si è verificato un errore durante il caricamento',
                activated: 'attivata',
                deactivated: 'disattivata',
                variability: 'Variabilità',
                intraspecificVariation:'Var. intraspec.',
                ontogeneticVariation:'Var. ontogen.',
                sexDim:'Dim. sessuale',
                dataType:'Tipologia di dati',
                hasDescription:'Descrizione',
                hasFigure:'Figure',
                hasScoring:'Punteggio',
                hasGeometricMorphology:'Morf. Geom.',
                hasFiniteElementsAnalysis:'F.E.A.',
                techniques:'Tecniche',
                drySkeleton:'Scheletro',
                clearingAndStaining:'Puliz. e coloraz.',
                ctScan:'Tom. comput.',
                xRays:'Raggi X',
                histological:'Istologica',
                noLinkedResearch: 'Nessuna ricerca collegata',
                researchData:'Dati ricerca',
                abc:'A,B,C...',
                newSpeciesDescribed: 'Descrizione di nuova specie',
                missingSpecies: 'Il campo specie è obbligatorio',
                missingReference: 'Il campo riferimento è obbligatorio',
                delete: 'elimina',
                deleteSelected: 'elimina selezionati',
                multipleSelection: 'Selezione multipla',
                filter: 'Filtra',
                apply: 'Applica',
                advancedSearch: 'Ricerca avanzata',
                removeFilters: 'Rimuovi filtri',
                upload: 'Carica',
                uploadHelpText: 'Tramite questa pagina puoi importare dati tramite un file in formato .xlsx, il file deve contenere un solo foglio di lavoro e deve essere strutturato come il file di esempio che puoi scaricare qui sotto:',
                downloadExampleFile: 'Scarica il file di esempio',
                uploadHelpTextPart2: 'Dopo aver compilato correttamente il file puoi caricarlo qui sotto e premere il tasto "Carica" a fondo pagina',
                finalizeImport: 'Finalizza importazione',
                finalizeImportNewSpeciesPart1: 'Verranno importate ',
                finalizeImportNewSpeciesPart2: 'nuove specie, non precedentemente presenti nel database',
                cancelImport: 'Annulla importazione',
                finalizeImportResearches: 'nuove ricerche saranno importate',
                importingTitle: 'Importazione in corso...',
                importingText: 'Il sistema sta creando le risorse presenti nel file di importazione...',
                confirmResearchesDeletion:'Ricerche eliminate con successo',
                importSuccess: 'Nuovi dati importati con successo!',
                verifiedBy: 'Verificato da'
            }
        },
        'en': {
            views: {
                Home: 'Home',
                Login: 'Log in',
                Species: 'Species',
                Researches: 'Researches',
                Research: 'Research',
                AddSpecies: 'Add species',
                SpeciesSingle: 'Species',
                EditSpecies: 'Edit species',
                ResearchAdd: 'Add research',
                Import: 'Import file'
            },
            errors: {
                valid: 'Value has to be valid',
                required: 'Value is required'
            },
            labels:{
                hello: 'Hello',
                logout: 'Logout',
                resetPassword: 'Reset password',
                pwdFor: 'The password for',
                willBeResetted:'will be resetted',
                pwdMinLen: 'The new password must contain at least 8 characters',
                oldPassword: 'Old password',
                newPassword: 'New password',
                confirmNewPassword: 'Confirm new password',
                cancel: 'Cancel',
                confirm: 'Confirm',
                results: 'Results',
                search: 'Search...',
                multiselect: 'Multiple selection',
                binomial: 'Binomial nomenclature',
                genus: 'Genus',
                family: 'Family',
                selectFamily: 'Select family',
                order: 'Order',
                selectOrder: 'Select order',
                suborder: 'Suborder',
                continents: 'Continents',
                anatomicParts: 'Anatomic parts',
                reference: 'Reference',
                year: 'Year',
                notes: 'Notes',
                specimenCount: 'Specimen count',
                registeredBy: 'Registered by',
                researchDeleted: 'Research deleted',
                cranium: 'Cranium',
                lowerJaw: 'Low jaw',
                teeth: 'Teeth',
                hyoid: 'Hyoid',
                vertebrae: 'Vertebrae',
                ribs: 'Ribs',
                girdles: 'Girdles',
                limbs: 'Limbs',
                osteoderms: 'Osteoderms',
                shell: 'Shell',
                oceania: 'Oceania',
                asia: 'Asia',
                europe: 'Europe',
                africa: 'Africa',
                america: 'America',
                moreResults: 'Show more results',
                specificEpithet: 'Specific epithet',
                choose: 'Choose',
                confirmDeletion: 'Confirm deletion',
                speciesData: 'Species data',
                confirmSpeciesQuestion: 'Do you really want to delete this species?',
                selectUnderOrderGrouping: 'Choose grouping below order',
                selectGenus: 'Choose genus',
                underOrderGrouping: 'Grouping below order',
                none: 'None',
                yesDelete: 'Yes, delete',
                speciesDeleted: 'Species deleted',
                reallyDelete: 'Do you really wanna delete',
                thisResearch: 'this research',
                errorLoading: 'Error during data loading',
                activated: 'activated',
                deactivated: 'deactivated',
                variability: 'Variability',
                intraspecificVariation:'Intraspec. var.',
                ontogeneticVariation:'Ontogenetic var.',
                sexDim:'Sex. dim.',
                dataType:'Data type',
                hasDescription:'Description',
                hasFigure:'Figure',
                hasScoring:'Scoring',
                hasGeometricMorphology:'Geom. Morph.',
                hasFiniteElementsAnalysis:'F.E.A.',
                techniques:'Techniques',
                drySkeleton:'Dry skel.',
                clearingAndStaining:'Cl. & st.',
                ctScan:'CT scan',
                xRays:'X-rays',
                histological:'Histol.',
                noLinkedResearch: 'No linked research',
                researchData:'Research data',
                abc:'A,B,C...',
                newSpeciesDescribed: 'New species described',
                missingSpecies: 'The species field is compulsory',
                missingReference: 'The reference field is compulsory',
                delete: 'delete',
                deleteSelected: 'delete selected',
                multipleSelection:'Multiple selection',
                filter: 'Filter',
                apply: 'Apply',
                advancedSearch: 'Advanced search',
                removeFilters: 'Remove filters',
                upload: 'Upload',
                uploadHelpText: 'Using this page, you can import data via an .xlsx file. The file must contain only one worksheet and be structured like the example file you can download here:',
                downloadExampleFile: 'Download example file',
                uploadHelpTextPart2: 'After completing the file correctly you can upload it below and press the "Upload" button at the bottom of the page.',
                finalizeImport: 'Finalize import',
                finalizeImportNewSpeciesPart1: '',
                finalizeImportNewSpeciesPart2: 'new species, that were not present in the database, will be created',
                cancelImport: 'Cancel import',
                finalizeImportResearches: 'new researches will be imported',
                importingTitle: 'Importing in progress...',
                importingText: 'Creating the new resources from the uploaded file...',
                confirmResearchesDeletion:'Researches successfully deleted',
                importSuccess: 'New data imported successfully!',
                verifiedBy: 'Verified by'
            }
        },
    }

})
